import { Box, Link, Stack, Typography } from "@mui/material";

import { useNavigate, useLocation } from "react-router-dom";

import { useMixPanel } from '../../../hooks/useMixPanel';

import { OfficeAvatar } from "../../../components/OfficeAvatar";

const PartnersNameCell = ({ params: member, profilePictureUrl }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { logEvent } = useMixPanel();

  const handleNameClick = () => {
    logEvent("open_profile", {
      location: "partners_page",
      user_type: "distributor"
    })
    navigate(`${location.pathname}${location.search ? location.search : "?"}&drawer=partner&id=${member.unicityId}&drawerContent=profile`, {
      state: {
        location: location,
        userFirstName: member.firstName,
        userFullName: member.name,
        totalPartners: member.totalPartners,
      },
    });
  };

  return (
    <Box
      className="flex-row"
      data-test-id="name-cell-container"
      data-field="name-cell-container"
      gap={1}
      sx={{ opacity: member.customerStatus === "Suspended" && ".6" }}
    >
      <Box>
        <OfficeAvatar
          imageUrl={profilePictureUrl}
          firstInitial={member.name[0]?.toUpperCase()}
          id="first-letter"
        />
      </Box>
      <Box className="flex-column" style={{ alignItems: "flex-start" }}>
        <Stack direction="row">
          <Link
            sx={{ fontSize: "12px" }}
            component="button"
            underline="hover"
            href="#"
            onClick={handleNameClick}
          >
            <Box
              data-field="full-name-container"
              data-test-id="full-name-container"
            >
              <span
                style={{ fontWeight: 400 }}
                data-field="first-name"
                data-test-id="first-name"
              >
                {member.firstName}
              </span>{" "}
              <span
                style={{ fontWeight: 600 }}
                data-field="last-name"
                data-test-id="last-name"
              >
                {member.lastName}
              </span>
            </Box>
          </Link>
          {member.customerStatus === "Suspended" ? (
            <Stack
              justifyContent="center"
              data-test-id="suspended-chip">
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "9px",
                  backgroundColor: "#FFEEEE",
                  color: "#DF4747",
                  borderRadius: "38px",
                  padding: "1px 8px",
                  marginLeft: "4px",
                }}
              >
                Suspended
              </Typography>
            </Stack>
          ) : (
            !member.is100PvActive && (
              <Stack
                justifyContent="center"
                data-test-id="inactive-chip">
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: "9px",
                    color: "#153862",
                    backgroundColor: "#EDEFF1",
                    borderRadius: "38px",
                    padding: "1px 8px",
                    marginLeft: "4px",
                  }}
                >
                  Inactive
                </Typography>
              </Stack>
            )
          )}
        </Stack>
        <Box
          data-field="unicity-id"
          data-test-id="unicity-id"
          style={{ fontSize: "10px", fontWeight: 400, opacity: "60%" }}
        >
          {member.unicityId}
        </Box>
      </Box>
    </Box>
  );
};

export { PartnersNameCell };
